import { createStyles, makeStyles } from '@material-ui/core';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
//import { TextFieldProps as BaseTextFieldProps } from '@material-ui/core/TextField/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField, { TextFieldProps as BaseTextFieldProps } from '@mui/material/TextField';
import clsx from 'clsx';
import {isEqual, isFuture, isPast, isValid, set} from 'date-fns';
import pt from 'date-fns/locale/pt';
import React from 'react';
import { Controller } from "react-hook-form";

export type TextFieldProps = BaseTextFieldProps & {
    name: string;
    control: any;
    disable?: boolean;
    allowToday?: boolean;
    allowPast?: boolean;
    allowFuture?: boolean;
    dateAndTime?: boolean;
    maxDate?: Date | null;
    minDate?: Date | null;
    shouldDisableDate?: (date: any[]) => boolean;
};

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            margin: '10px',
        },
    })
);  



const DateField: React.FC<TextFieldProps> = ({
  name,
  helperText,
  defaultValue,
  InputLabelProps,
  autoFocus,
  type,
  control,
  onChange,
  disable,
  inputProps,
  label,
  allowToday,
  allowPast,
  allowFuture,
  dateAndTime = false,
  maxDate = null,
  minDate = null,
  shouldDisableDate,
  ...restProps
}) => {
  const classes = useStyles();
  const today = set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0});

  //Define se esta data do calendario deve estar desabilitada ou nao:
  const disableDate = (date: any) => {
    //Se foi passado uma funcao especifica, utilizar a mesma:
    if (shouldDisableDate !== undefined)
      return shouldDisableDate(date);

    //Senao, habilitar baseado nas opcoes allowToday, etc:
    if (isEqual(date, today)) //today
      return allowToday !== undefined && !allowToday;
    else if (isPast(date))
      return allowPast !== undefined && !allowPast;
    else if (isFuture(date))
      return allowFuture !== undefined && !allowFuture;

    return false;
  };

  return (
    <Controller
    name={name}
    control={control}
    render={({ field, fieldState: { error } }) => (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pt}>
        

        {dateAndTime ? 
            <>
                <DesktopDateTimePicker
                  disabled={disable}
                  ref={field.ref}
                  value={field.value}
                  label={label}
                  inputFormat="dd/MM/yyyy HH:mm"
                  onChange={e => {
                    
                      if (e === '' || e == null){
                        field.onChange(null)
                        return
                      }

                      if (!isValid(e))
                        field.onChange("");
                      else
                      {
                        if (onChange !== undefined)
                          onChange(e);

                        field.onChange(e === null ? null : 
                          e.toLocaleDateString('pt-BR').split('/')[2] + '-' + e.toLocaleDateString('pt-BR').split('/')[1] + '-' + e.toLocaleDateString('pt-BR').split('/')[0] + 'T' + e.toLocaleTimeString('pt-BR').split(':')[0] + ':' +  e.toLocaleTimeString('pt-BR').split(':')[1]);
                      }
                  }}          
                  className={clsx(classes.root)}
                  shouldDisableDate={disableDate}
                  renderInput={(params) => 
                    <TextField 
                      {...restProps}
                      inputRef={field.ref} 
                      name={name} 
                      value={field.value} 
                      defaultValue={defaultValue}
                      variant="standard" 
                      className={clsx(classes.root)} 
                      disabled={disable}
                      error={false}
                      helperText={error ? error.message : null}            
                      {...params} 
                      style={{
                        marginLeft: "10px",
                        marginTop: "8px"
                      }}
                      fullWidth
                      autoFocus={autoFocus}
                      inputProps={{
                        ...params.inputProps,
                        placeholder:"dd/mm/aaaa --:--"
                      }}
                      InputLabelProps={{
                          ...InputLabelProps,
                          shrink:true
                      }}      
                    />
                }/>
            </> 
          : 
              <>
                <DesktopDatePicker
                  disabled={disable}
                  ref={field.ref}
                  value={field.value}
                  label={label}
                  inputFormat="dd/MM/yyyy"
                  maxDate={maxDate}
                  minDate={minDate}
                  onChange={e => {

                      if (e === '' || e == null){
                        field.onChange(null)
                        return
                      }

                      if (!isValid(e))
                        field.onChange("");
                      else
                      {
                        if (onChange !== undefined)
                          onChange(e);

                        field.onChange(e === null ? null : e.toLocaleDateString('pt-BR').split('/')[2] + '-' + e.toLocaleDateString('pt-BR').split('/')[1] + '-' + e.toLocaleDateString('pt-BR').split('/')[0] + ' 00:00:00');
                      }
                    }}          
                  className={clsx(classes.root)}
                  shouldDisableDate={disableDate}
                  renderInput={(params) => 
                    <TextField 
                      {...restProps}
                      inputRef={field.ref} 
                      name={name} 
                      value={field.value} 
                      defaultValue={defaultValue}
                      variant="standard" 
                      className={clsx(classes.root)} 
                      disabled={disable}
                      error={false}
                      helperText={error ? error.message : null}            
                      {...params} 
                      style={{
                        marginLeft: "10px",
                        marginTop: "8px"
                      }}
                      fullWidth
                      autoFocus={autoFocus}
                      inputProps={{
                        ...params.inputProps,
                        placeholder:"dd/mm/aaaa"
                      }}
                      InputLabelProps={{
                          ...InputLabelProps,
                          shrink:true
                      }}      
                    />
                }/>
            </>
        }

    </LocalizationProvider>
    )}
    />

  );
}

export default React.memo(DateField);